import { useNavigate } from 'react-router';

export function DashboardPage(): React.JSX.Element {
  const navigate = useNavigate();

  return (
    <div>
      <h1>Обзор платформы 🚀</h1>

      <div className="grid-stats">
        <button className="card" onClick={() => navigate('/staff')}>
          <span className="card-icon">👥</span>
          <span className="card-label">Владельцев</span>
          <span className="card-value">24</span>
          <span className="card-sub">+3 за неделю</span>
        </button>
        
        <div className="card">
          <span className="card-icon">📈</span>
          <span className="card-label">Всего записей</span>
          <span className="card-value">1,284</span>
          <span className="card-sub">+12%</span>
        </div>

        <div className="card">
          <span className="card-icon">💎</span>
          <span className="card-label">Выручка (SaaS)</span>
          <span className="card-value">84.2к</span>
          <span className="card-sub">+5.4к</span>
        </div>

        <button className="card" onClick={() => navigate('/settings')}>
          <span className="card-icon">🛡️</span>
          <span className="card-label">Контроль</span>
          <span className="card-value">Active</span>
          <span className="card-sub">System OK</span>
        </button>
      </div>

      <div className="section-title">Активные владельцы</div>
      
      <div className="booking-item">
        <div className="booking-info">
          <h4>Салон «Элегант»</h4>
          <p>Владелец: Владимир В.</p>
        </div>
        <div className="booking-time">
          <div className="time-val">PRO</div>
          <span className="status-badge status-confirmed">Активен</span>
        </div>
      </div>

      <div className="booking-item">
        <div className="booking-info">
          <h4>Barber Shop No.1</h4>
          <p>Владелец: Артем М.</p>
        </div>
        <div className="booking-time">
          <div className="time-val">FREE</div>
          <span className="status-badge status-confirmed">Активен</span>
        </div>
      </div>

      <div style={{ marginTop: '30px' }}>
        <button className="card" style={{ width: '100%', alignItems: 'center', backgroundColor: 'var(--tg-btn)', color: 'white' }}>
          <span className="card-icon">➕</span>
          <span className="card-label" style={{ color: 'white', opacity: 0.8 }}>Добавить владельца</span>
        </button>
      </div>
    </div>
  );
}
